import React from 'react';
export function Footer() {
  return <footer className="bg-stone-50 py-8 border-t border-stone-200 text-center px-4" data-id="element-137" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-138" data-mp="3gg0zo4mhnzy6">
        <p className="text-stone-500 text-sm" data-id="element-139" data-mp="32nukakr5twzs">
          © {new Date().getFullYear()} Makeup Instructor Ready — All rights
          reserved.
        </p>
      </div>
    </footer>;
}